import { useEffect, useState, useCallback } from "react";
import tradeColumns from "../../../../columns/trades.jsx";
import TableWithSkeleton from "../../../../components/table/TableWithSkeleton";
import { GetFirstLevelOpenTradeApi } from "../../../../api/request/liveAccount.js";

const POLLING_INTERVAL = 10000;

const OpenTrades = () => {
  const [liveData, setLiveData] = useState([]);

  const columns = tradeColumns.filter((column) => column.dataIndex !== "close");

  const fetchData = useCallback(async () => {
    try {
      const { data } = await GetFirstLevelOpenTradeApi();
      if (data?.success) {
        const items = Array.isArray(data?.data) ? data.data : data?.data?.data || [];
        setLiveData(items);
      }
    } catch (error) { }
  }, []);

  useEffect(() => {
    fetchData();
    const interval = setInterval(fetchData, POLLING_INTERVAL);
    return () => clearInterval(interval);
  }, [fetchData]);

  return <TableWithSkeleton columns={columns} data={liveData} />;
};

export default OpenTrades;
